module.exports = __webpack_public_path__ + "static/media/rice.a0e3fd28.jpg";